import React, { memo } from 'react';
import { Block } from '../../components/core';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { useRecoilValue } from 'recoil';
import { isReportState } from 'venn-state';
import { DistributionHeader } from './distribution-header';
import { DistributionContent } from './distribution-content';
import { NoMetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/NoMetricsErrorWrapper';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';

export const DistributionBlock = memo(function InternalDistributionBlock({ id }: { id: string }) {
  const isReport = useRecoilValue(isReportState);

  return (
    <Block.Root id={id} draggable={isReport}>
      <Block.Header>
        <DistributionHeader id={id} />
      </Block.Header>
      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper, NoMetricsErrorWrapper]}>
        <DistributionContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
